export default __webpack_public_path__ + "static/media/Security.0c0014e7.svg";